import React, {useMemo} from 'react';

import Protein from 'molbio/aa-sequences/AaSequence';
import {TabView, SimplifiedOptionsView} from 'molbio/maps/linear/AaSequenceMapView';
import PolymerMapWrapper from 'molbio/maps/standalone/PolymerMapWrapper';
import ProteinMapTabState from 'molbio/tabstates/AaSequenceMapTabState';

export default function ProteinMapContainer({
  protein,
  className,
}: {
  protein: Protein;
  className?: string;
}): JSX.Element {
  const proteinMapTabState = useMemo(() => new ProteinMapTabState({protein}), [protein]);
  return (
    <PolymerMapWrapper
      className={className}
      TabOptionsViewCls={SimplifiedOptionsView}
      TabContentViewCls={TabView}
      tabState={proteinMapTabState}
    />
  );
}
